class VehicleBrandMegaMenu extends HTMLElement {
  constructor() {
    super();
    this.initialize();
  }

  connectedCallback() {
    this.initialize();
  }

  initialize() {
    if (this.vehicleBrandInitialized) return;

    this.details = this.querySelector('details');
    this.summary = this.querySelector('summary');
    this.body = this.querySelector('.vehicle-brand-mega-menu__body');
    this.closeTimer = null;

    if (!this.details || !this.summary || !this.body) return;
    this.vehicleBrandInitialized = true;

    this.openMenu = this.openMenu.bind(this);
    this.scheduleClose = this.scheduleClose.bind(this);
    this.cancelClose = this.cancelClose.bind(this);
    this.onDocumentClick = this.onDocumentClick.bind(this);
    this.onKeyUp = this.onKeyUp.bind(this);

    this.summary.addEventListener('mouseenter', this.openMenu);
    this.addEventListener('mouseenter', this.cancelClose);
    this.addEventListener('mouseleave', this.scheduleClose);
    document.addEventListener('click', this.onDocumentClick);
    this.addEventListener('keyup', this.onKeyUp);
  }

  openMenu() {
    if (window.matchMedia('(max-width: 989px)').matches) return;

    this.cancelClose();
    document
      .querySelectorAll('[id^="Details-HeaderMenu-"][open], [id^="ProductsMegaMenu-"][open], [id^="VehicleBrandMegaMenu-"][open]')
      .forEach((details) => {
        if (details !== this.details) details.removeAttribute('open');
      });

    this.details.setAttribute('open', '');
    this.summary.setAttribute('aria-expanded', 'true');
  }

  scheduleClose() {
    if (window.matchMedia('(max-width: 989px)').matches) return;
    this.cancelClose();
    this.closeTimer = window.setTimeout(() => this.closeMenu(), 320);
  }

  cancelClose() {
    if (!this.closeTimer) return;
    window.clearTimeout(this.closeTimer);
    this.closeTimer = null;
  }

  closeMenu() {
    this.details.removeAttribute('open');
    this.summary.setAttribute('aria-expanded', 'false');
  }

  onDocumentClick(event) {
    if (this.details.hasAttribute('open') && !this.contains(event.target)) {
      this.closeMenu();
    }
  }

  onKeyUp(event) {
    if (event.code && event.code.toUpperCase() === 'ESCAPE') {
      this.closeMenu();
      this.summary.focus();
    }
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.onDocumentClick);
  }
}

function hydrateVehicleBrandBlocks(root = document) {
  root.querySelectorAll('[data-vehicle-brand-grid-source]').forEach((target) => {
    const blockId = target.dataset.vehicleBrandGridSource;
    const template = document.querySelector(`template[data-vehicle-brand-template="${blockId}"]`);

    if (!template || target.dataset.vehicleBrandHydrated === 'true') return;

    target.replaceChildren(template.content.cloneNode(true));
    target.dataset.vehicleBrandHydrated = 'true';
  });
}

function vehicleMenuHandle(value) {
  return (value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

function vehicleMenuVariables(template) {
  return [
    `--vehicle-menu-bg: ${template.dataset.menuBackground}`,
    `--vehicle-menu-text: ${template.dataset.menuText}`,
    `--vehicle-menu-hover: ${template.dataset.menuHover}`,
    `--vehicle-menu-radius-top-left: ${template.dataset.radiusTopLeft}px`,
    `--vehicle-menu-radius-top-right: ${template.dataset.radiusTopRight}px`,
    `--vehicle-menu-radius-bottom-right: ${template.dataset.radiusBottomRight}px`,
    `--vehicle-menu-radius-bottom-left: ${template.dataset.radiusBottomLeft}px`
  ].join('; ');
}

function vehicleBrandGrid(template, mobile = false) {
  const mega = document.createElement('div');
  mega.className = `vehicle-brand-mega${mobile ? ' vehicle-brand-mega--mobile' : ''}`;
  mega.dataset.vehicleBrandMega = '';
  mega.setAttribute('style', vehicleMenuVariables(template));

  if (template.dataset.menuHeading) {
    const heading = document.createElement('p');
    heading.className = 'vehicle-brand-mega__heading';
    heading.textContent = template.dataset.menuHeading;
    mega.appendChild(heading);
  }

  const grid = document.createElement('div');
  grid.className = 'vehicle-brand-mega__grid';
  grid.appendChild(template.content.cloneNode(true));
  mega.appendChild(grid);
  return mega;
}

function connectDesktopVehicleMenu(template) {
  const targetHandle = template.dataset.menuHandle;
  if (!targetHandle) return;

  document.querySelectorAll('.header__inline-menu > .list-menu > li').forEach((item, index) => {
    if (item.querySelector(':scope > vehicle-brand-mega-menu')) return;

    const original = item.querySelector(
      ':scope > a.header__menu-item--main, :scope > header-menu summary.header__menu-item--main, :scope > products-mega-menu summary.header__menu-item--main'
    );
    if (!original || vehicleMenuHandle(original.textContent) !== targetHandle) return;
    const replaceTarget = original.closest('header-menu, products-mega-menu') || original;

    const menu = document.createElement('vehicle-brand-mega-menu');
    menu.className = 'vehicle-brand-mega-menu';
    const details = document.createElement('details');
    details.id = `VehicleBrandMegaMenu-Fallback-${template.dataset.vehicleBrandTemplate}-${index}`;
    details.className = 'vehicle-brand-mega-menu__details';

    const summary = document.createElement('summary');
    summary.className = 'header__menu-item header__menu-item--main list-menu__item link focus-inset vehicle-brand-mega-menu__summary';
    summary.setAttribute('aria-expanded', 'false');
    const label = document.createElement('span');
    label.textContent = original.textContent.trim();
    summary.appendChild(label);
    summary.insertAdjacentHTML('beforeend', '<svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 1 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708Z" fill="currentColor"/></svg>');

    const body = document.createElement('div');
    body.className = 'vehicle-brand-mega-menu__body';
    body.tabIndex = -1;
    body.setAttribute('style', vehicleMenuVariables(template));
    body.appendChild(vehicleBrandGrid(template));

    details.append(summary, body);
    menu.appendChild(details);
    replaceTarget.replaceWith(menu);
  });
}

function connectMobileVehicleMenu(template) {
  const targetHandle = template.dataset.menuHandle;
  if (!targetHandle) return;

  document.querySelectorAll('nav.menu-drawer__navigation > ul.menu-drawer__menu > li').forEach((item, index) => {
    if (item.querySelector(':scope > details.vehicle-brand-mobile-details, :scope > .menu-drawer__submenu--vehicle-brands')) return;

    const original = item.querySelector(
      ':scope > a.menu-drawer__menu-item, :scope > details > summary.menu-drawer__menu-item'
    );
    if (!original || vehicleMenuHandle(original.textContent) !== targetHandle) return;

    const details = document.createElement('details');
    details.className = 'vehicle-brand-mobile-details';
    details.id = `VehicleBrandMobileMenu-${template.dataset.vehicleBrandTemplate}-${index}`;

    const summary = document.createElement('summary');
    summary.className = original.className || 'menu-drawer__menu-item list-menu__item link link--text focus-inset';
    const label = document.createElement('span');
    label.className = 'vehicle-brand-mobile-details__label';
    label.textContent = original.textContent.trim();
    summary.appendChild(label);
    summary.insertAdjacentHTML('beforeend', '<svg aria-hidden="true" focusable="false" class="icon icon-caret vehicle-brand-mobile-details__arrow" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 1 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708Z" fill="currentColor"/></svg>');

    const panel = document.createElement('div');
    panel.className = 'vehicle-brand-mobile-panel';
    panel.setAttribute('style', vehicleMenuVariables(template));
    panel.appendChild(vehicleBrandGrid(template, true));

    details.append(summary, panel);
    item.replaceChildren(details);
  });
}

function connectVehicleBrandMenus() {
  document.querySelectorAll('template[data-vehicle-brand-template][data-menu-handle]').forEach((template) => {
    connectDesktopVehicleMenu(template);
    connectMobileVehicleMenu(template);
  });
}

if (!customElements.get('vehicle-brand-mega-menu')) {
  customElements.define('vehicle-brand-mega-menu', VehicleBrandMegaMenu);
}

connectVehicleBrandMenus();
hydrateVehicleBrandBlocks();
document.addEventListener('DOMContentLoaded', () => {
  connectVehicleBrandMenus();
  hydrateVehicleBrandBlocks();
});
document.addEventListener('shopify:section:load', (event) => {
  connectVehicleBrandMenus();
  hydrateVehicleBrandBlocks(event.target);
});
document.addEventListener('shopify:block:select', () => {
  connectVehicleBrandMenus();
  hydrateVehicleBrandBlocks();
});
